export {TimestampConnect as default} from './Timestamp.connect';
